<template>
  <div class="tender-head-container">
    <div class="tender-head clearfix">
      <div class="tender-head-info clearfix">
        <div
          v-show="showHeaderNavStrip"
          class="tender-head-top"
        >
          <HKLHeader
            v-if="showHeaderNavStrip"
            linkClassLeftPrimary="back"
            :labelLeftPrimary="tenderHklLeftPrimaryLabel"
            :labelRightLeading="$t('listNavigation.previousRecord')"
            :labelRightTrailing="$t('listNavigation.nextRecord')"
            :navigationEntries="tenderListNavEntriesForHeader"
            :currentRecordId="$route.params.id"
            @left-primary="onTenderHklLeftPrimary"
            @right-leading="onTenderListNavEntry"
            @right-trailing="onTenderListNavEntry"
          />
        </div>

        <Lifecycle
          ref="tenderLifecycle"
          modalId="tender-modules-lifecycle-modal"
          :type="'tender'"
          :commentAttr="lifecycleCommentAttrs.rejectReason"
          :histories="currentTenderHistory"
        />

        <div class="tender-info-with-status">
          <div class="tender-info clearfix">
            <div class="tender-project__number"># {{ (tenderGeneral.prNumber !== 0) ? tenderGeneral.prNumber : '' }}</div>
            <div class="row no-margin-left">
              <div class="tender-project__name">{{ tenderGeneral.prDescription || '' }}<TenderOptions /></div>
            </div>
          </div>

          <div class="clearfix">
            <slot name="status">
              <div
                :class="statusStyle"
                @click="openLifecycleModal()"
              >{{ statusText }}</div>
            </slot>
            <div class="float-right tender-view-button-bar clearfix">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HKLHeader from '@/controls/HKLHeader'
import { lifecycleCommentAttrs, tenderRouteNames } from '@/utils/consts'
import HomeLink from '@/controls/HomeLink'
import Lifecycle from '@/modules/Lifecycle'
import TenderOptions from '@/modules/tenders/TenderOptions'
import { parseStatusText } from '@/api/tenders/request'
import { LIST_NAV_KIND, mergeListNavigationHeaderPaths, pushListNavigationEntry, resolveNavigationKind } from '@/constants/listNavigation'
import { VIEW_ALL_RESUME_SEARCH_QUERY } from '@/constants/viewAllTableCache'
import navigation from '@/utils/navigation'

export default {
  name: 'tender-head',
  data () {
    return {
      lifecycleCommentAttrs,
    }
  },
  props: {
    tenderGeneral: Object,
  },
  components: {
    HKLHeader, HomeLink, Lifecycle, TenderOptions,
  },
  watch: {
    '$route.params.id': 'syncTenderListNavigationWithRoute',
  },
  mounted () {
    this.syncTenderListNavigationWithRoute()
  },
  methods: {
    ...mapActions('listNavigation', ['clearListNavigationSequence']),
    openLifecycleModal () {
      this.$refs.tenderLifecycle.init()
    },
    navBack () {
      this.$router.goBack()
    },
    syncTenderListNavigationWithRoute () {
      const routeId = this.$route.params.id
      if (routeId == null || routeId === '') return
      const cur = String(routeId)
      const seq = this.listNavigationSequence || []
      if (seq.length && !seq.some(e => String(e.id) === cur)) {
        this.clearListNavigationSequence()
      }
    },
    onTenderHklLeftPrimary () {
      if (this.hasTenderListNavigation) {
        navigation.toPage(tenderRouteNames.tenders, {}, { [VIEW_ALL_RESUME_SEARCH_QUERY]: '1' })
      } else {
        this.navBack()
      }
    },
    onTenderListNavEntry (entry) {
      pushListNavigationEntry(this.$router, this.$route, this.tenderListNavMergedPaths, entry)
    },
  },
  computed: {
    ...mapGetters('tenders', ['currentTenderHistory']),
    ...mapGetters('listNavigation', ['listNavigationSequence']),
    showHeaderNavStrip () {
      return this.hasTenderListNavigation || this.shouldNavBack
    },
    shouldNavBack () {
      const routeId = this.$route.params.id
      if (routeId != null && routeId !== '') return true
      const p = this.$route.params.prev
      return ['viewAll', 'projectDetail', tenderRouteNames.tenders].includes(p)
    },
    hasTenderListNavigation () {
      const seq = this.listNavigationSequence || []
      const cur = String(this.$route.params.id)
      if (!seq.length) return false
      const allSameKind = seq.every(e => resolveNavigationKind(e) === LIST_NAV_KIND.TENDER_RECORD)
      const containsCur = seq.some(e => String(e.id) === cur)
      return allSameKind && containsCur
    },
    tenderListNavEntriesForHeader () {
      return this.hasTenderListNavigation ? this.listNavigationSequence : []
    },
    tenderListNavMergedPaths () {
      return mergeListNavigationHeaderPaths({}, '', '')
    },
    tenderHklLeftPrimaryLabel () {
      return this.hasTenderListNavigation
        ? this.$t('listNavigation.backToSearchResults')
        : this.$t('back')
    },
    statusStyle () {
      if (this.tenderGeneral.status) {
        const lowerCasestatus = this.tenderGeneral.status.toLowerCase()
        return `tender-status-${lowerCasestatus} tender-status float-left`
      }
      return 'tender-status float-left'
    },
    statusText () {
      return parseStatusText(this.tenderGeneral)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/view';
.tender-view-button-bar {
  .btn {
    margin-left: 15px;
  }
}

.no-margin-left {
  margin-left: 0;
}

.tender-head-top {
  font-family: Verdana;
  font-size: 12px;

  a {
    color: #0C3A58;
  }
  i {
    margin-right: 0.5vw;
    font-size: 16px;
  }
}
</style>
